module.exports = __webpack_public_path__ + "static/image3-6f496ecdbd526e0d2fd62589b282bbe4.jpg";